import { Mail, MessageCircle } from "lucide-react";
import { config } from "@/config";

const footerLinks = {
  propuesta: [
    { label: "Contenido", href: "#contenido" },
    { label: "Herramientas", href: "#herramientas" },
    { label: "Comunidad", href: "#comunidad" },
    { label: "Planes", href: "#planes" },
  ],
  soporte: [
    { label: "Preguntas frecuentes", href: "#faq" },
    { label: "Contacto", href: "#formulario" },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-[#050D18] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                DSA
              </span>
              <span className="text-xs uppercase tracking-[0.2em] text-gray-500 ml-3">
                Embajador Comercial
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 max-w-md">
              DSA actúa como embajador y canal de orientación, precalificación y acompañamiento comercial. 
              El programa educativo de Ecommerce referido en esta página es provisto por MINED.
            </p>
            <div className="flex gap-4">
              <a
                href={config.whatsapp.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#D4C4A8] flex items-center justify-center transition-colors group"
              >
                <MessageCircle size={18} className="text-white group-hover:text-[#0A1628]" />
              </a>
              <a
                href="mailto:contacto@dsaeconomiadigital.com"
                className="w-10 h-10 bg-white/10 hover:bg-[#D4C4A8] flex items-center justify-center transition-colors group"
              >
                <Mail size={18} className="text-white group-hover:text-[#0A1628]" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-[0.2em] text-white mb-6">
              Propuesta
            </h4>
            <ul className="space-y-3">
              {footerLinks.propuesta.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-[#D4C4A8] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-[0.2em] text-white mb-6">
              Soporte
            </h4>
            <ul className="space-y-3">
              {footerLinks.soporte.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-[#D4C4A8] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Legal Notice */}
        <div className="border-t border-white/10 py-8">
          <div className="bg-white/5 p-6 mb-8">
            <h5 className="text-xs font-bold uppercase tracking-[0.15em] text-white mb-3">
              Aviso Legal
            </h5>
            <p className="text-xs text-gray-400 leading-relaxed">
              DSA actúa como canal de orientación, captación y acompañamiento comercial. 
              El programa educativo referido en esta página es provisto por MINED. 
              La información presentada tiene fines informativos y de evaluación comercial.
            </p>
          </div>

          <div className="bg-white/5 p-6 mb-8">
            <h5 className="text-xs font-bold uppercase tracking-[0.15em] text-white mb-3">
              Política de Privacidad
            </h5>
            <p className="text-xs text-gray-400 leading-relaxed">
              Los datos proporcionados a través de esta página serán utilizados por DSA para: 
              contacto informativo, evaluación comercial, seguimiento y orientación sobre la 
              oferta consultada. No compartimos tus datos con terceros no relacionados con 
              el proceso de orientación comercial.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © {currentYear} Digital Strategy Agency (DSA). Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-xs text-gray-500">
            <a href="/terminos" className="hover:text-gray-400 transition-colors">
              Términos y condiciones
            </a>
            <a href="/privacidad" className="hover:text-gray-400 transition-colors">
              Política de privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
